import { IMenu, IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IComponentController } from 'angular';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
interface IPageMc2044 extends IComponentController {
    menuBandeau: IMenu;
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
}
/* @ngInject */
export default function Mc2044Controller(
    Menu: IMenuClass,
    ac0010Route: IRoute,
    cp2010Route: IRoute,
    gl0003Route: IRoute,
    mc0109Route: IRoute,
    db0005Route: IRoute,
    cr0013Route: IRoute,
    cr0007Route: IRoute,
    cr0024Route: IRoute,
    cp2014Route: IRoute,
    cp2015Route: IRoute,
    cr0016Route: IRoute,
    mc0101Route: IRoute,
    in0043Route: IRoute,
    cp2012Route: IRoute,
) {
    const vm: IPageMc2044 = this;
    
    vm.menuBandeau = new Menu([]);
    vm.multiOccurrenceOptions = {
        fonctions: {
            suiviModification: true,
            edition: false,
            supprime: false,
            exportation: false,
            selectionCycle: false
        },
        navigatePage: (data: any) => getForage(data),
        navigateParams: (data: any) => getParams(data),
        colonnesVisibles: [
            { nom: 'docaffnumdoc01', largeur: 300 },
            { nom: 'tydcod', largeur: 120 }
        ],
        colonnesCachees: ['ecrcod', 'docaffcleint01']
    };

    // Note : les routes en commentaire sont pour les écrans non encore
    // développés.  Activer la route seulement lorsque l'écran est développé.
    // Note bis : cette fonction est dupliquée dans mc0032, ils doivent correspondre
    function getForage(data: any): string {
        switch (data.ecrcod) {
            case 'GL0003-00':
                return gl0003Route.NAME;
            // case 'AC0070-00':
                // return ac0070Route.NAME;
            case 'AC0010-00':
                return ac0010Route.NAME;
            case 'CP0013-00':
                return cp2010Route.NAME;
            case 'CP0018-00':
                return cp2015Route.NAME;
            case 'CP0021-00':
                return cp2012Route.NAME;
            case 'CR0024-00':
                return cr0024Route.NAME;
            // case 'CP0018-00':
            //     return cp0018Route.NAME;
            // case 'CP0029-00':
            //     return cp0029Route.NAME;
            case 'CR0007-00':
                return cr0007Route.NAME;
            case 'CR0007_Z-00':
                return cr0007Route.NAME;
            case 'CR0013-00':
                return cr0013Route.NAME;
            case 'CR0016-00':
                return cr0016Route.NAME;
            case 'DB0005-00':
                return db0005Route.NAME;
            // case 'GL0020-00':
            //     return gl0020Route.NAME;
            // case 'IN0014-00':
            //     return in0014Route.NAME;
            case 'IN0043-00':
                return in0043Route.NAME;
            case 'MC0101-00':
                return mc0101Route.NAME;
            case 'MC0109-00':
                return mc0109Route.NAME;
            // case 'PD0006-00':
            //     return pd0006Route.NAME;
            case '':
                return cp2014Route.NAME;
            default:
                return undefined;
        }
    }
    // Cette fonction est dupliquée dans mc0032, ils doivent correspondre
    function getParams(data: any): any {
        switch (data.ecrcod) {
            case 'CP0013-00':
            case 'CP0018-00':
            case 'CP0021-00':
            case '':
                return { id: data.docaffcleint01 };
            default:
                return { id: data.doccleint };
        }
    }
    
}
